<div class="albums-container">
  <h3>Google Photos Frame</h3>

  <div *ngIf="loading" class="loading">Loading...</div>
  <div *ngIf="loadError" class="alert alert-danger">ERROR: {{ loadError }}</div>

  <!-- Picker Button -->
  <div *ngIf="showPickerButton && !loading && !loadError" class="picker-section">
    <p>Click the button below to select photos from your Google Photos library.</p>
    <button class="btn btn-primary btn-lg" (click)="openPicker()">
      Select Photos from Google Photos
    </button>
  </div>

  <!-- Selected Media Items -->
  <div *ngIf="selectedMediaItems.length > 0" class="media-items-section">
    <h4>Selected Photos ({{ selectedMediaItems.length }})</h4>
    <button class="btn btn-secondary" (click)="createNewPicker()" style="margin-bottom: 20px;">
      Select Different Photos
    </button>
    
    <div class="media-items-grid">
      <div *ngFor="let item of selectedMediaItems" class="media-item-card">
        <div class="media-item-image">
          <img [src]="getMediaItemUrl(item)" [alt]="item.filename" />
          <span class="media-type-badge">{{ getMediaType(item.mimeType) }}</span>
        </div>
        <div class="media-item-info">
          <h5 class="filename" [title]="item.filename">{{ item.filename }}</h5>
          
          <div class="media-details" *ngIf="item.description || item.createTime || item.creationTime || getDimensions(item)">
            <p class="description" *ngIf="item.description">{{ item.description }}</p>
            
            <div class="metadata">
              <span class="metadata-item" *ngIf="item.createTime || item.creationTime">
                <i class="fa fa-calendar"></i> {{ formatDate(item.createTime || item.creationTime) }}
              </span>
              <span class="metadata-item" *ngIf="getDimensions(item)">
                <i class="fa fa-arrows-alt"></i> {{ getDimensions(item) }}
              </span>
              <span class="metadata-item" *ngIf="item.mimeType">
                <i class="fa fa-file"></i> {{ item.mimeType }}
              </span>
            </div>
            
            <a *ngIf="item.productUrl" [href]="item.productUrl" target="_blank" class="view-in-photos">
              <i class="fa fa-external-link"></i> View in Google Photos
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Waiting for selection -->
  <div *ngIf="!showPickerButton && !selectedMediaItems.length && !loading && !loadError" class="waiting-section">
    <p>Waiting for you to select photos in the Google Photos picker...</p>
    <p class="text-muted">Please select photos in the window that opened.</p>
  </div>
</div>
